/**
 * Open a Basecamp ingestion ai_conversation in the agent panel chat surface.
 */

import { refreshChatsSidebar } from '@/lib/chats-sidebar-events'

const AUTO_OPEN_PREFIX = 'flownotes_ingestion_auto_open:'

/** Custom event: registry provider switches agent panel then loads conversation. */
export const OPEN_INGESTION_IN_AGENT_PANEL = 'open-ingestion-in-agent-panel'

export type OpenIngestionInAgentPanelDetail = {
  threadId: string
  conversationId: string
  title?: string
}

export function hasIngestionFileBeenAutoOpened(filePath: string): boolean {
  try {
    return sessionStorage.getItem(`${AUTO_OPEN_PREFIX}${filePath}`) != null
  } catch {
    return false
  }
}

export function markIngestionFileAutoOpened(filePath: string): void {
  try {
    sessionStorage.setItem(`${AUTO_OPEN_PREFIX}${filePath}`, String(Date.now()))
  } catch {
    /* ignore quota / private mode */
  }
}

export type OpenIngestionConversationOptions = {
  conversationId: string
  threadId?: string | null
  title?: string
}

/** Focus agent panel on ingestion thread and bootstrap conversation messages. */
export function openIngestionConversation(options: OpenIngestionConversationOptions): void {
  const { conversationId, title } = options
  const threadId = options.threadId ?? null

  refreshChatsSidebar()

  if (threadId) {
    window.dispatchEvent(
      new CustomEvent<OpenIngestionInAgentPanelDetail>(OPEN_INGESTION_IN_AGENT_PANEL, {
        detail: { threadId, conversationId, title },
      }),
    )
    return
  }

  // Degraded path when API did not return threadId yet
  window.dispatchEvent(
    new CustomEvent('open-chat-conversation', {
      detail: {
        conversationId,
        autoScroll: true,
        targetSurface: 'agent-panel',
      },
    }),
  )
}

/** Fire-and-forget wrapper for ingestion API callbacks. */
export function scheduleOpenIngestionConversation(
  conversationId: string | undefined,
  threadId?: string | null,
  title?: string,
): void {
  if (!conversationId) return
  openIngestionConversation({ conversationId, threadId, title })
}
